import React from "react";

const ChatDateDivider = ({ date }) => {
  return (
    <div style={styles.container}>
      <div style={styles.bubble}>
        <span style={styles.text}>{date}</span>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "12px 0",
    width: "100%",
  },
  bubble: {
    backgroundColor: "#ffffff",
    padding: "5px 12px",
    borderRadius: "7px",
    boxShadow: "0 1px 0.5px rgba(11,20,26,.08)",
    border: "1px solid rgba(0, 0, 0, 0.05)",
  },
  text: {
    fontSize: "11px",
    color: "#54656f",
    fontWeight: "500",
    fontFamily: "Raleway, sans-serif",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
  },
};

export default ChatDateDivider;
